import React from 'react';
import DriverItem from './DriverItem';
import CardWrapper from './CardWrapper';
//import { Link } from 'react-router-dom';


const DriverComponent = (props) => {
    console.log(props);
    const drivers = props.data.map((element, index) => {
        /**
         * maritalStatus
         * isSubjectActiveDuringMostRecentTerm : show a checkbox with a value and label
         * relationToPolicyHolder:
         * relationToInsured: 
         * dlNumber:
         * dlState
         * fromDate: this is the date someone was added to the policy
         * todate: is when the policy ends
         * dob: do a comparison and show one.  if we compare get first key
         * isSubjectVerified: person lives in the household. do not go through the lightspeed process if the subject is false
         */
        const driverName = `${element.givenName} ${element.surname}`;
        const { dobPrimarySource } = element.dob;
        const { relationToPolicyHolder } = element;
        console.log(element);
        return (
            <div key={index}>
                <DriverItem
                    onDriverClick={props.onDriverClick}
                    {...element}
                    name={driverName}
                    isPolicyHolder={relationToPolicyHolder.code === 'PP' ? true : false}
                    dateOfBirth={parseFloat(dobPrimarySource)} />
            </div>
        );
    })

    const numberDriversFound = props.data.length;

    return (
        <CardWrapper>
            <div>
                <h3>
                <i className="fa fa-id-card-o" aria-hidden="true"></i>
                     {numberDriversFound > 1 ? ' Drivers' : ' Driver'}
                     {/*
                         found - {numberDriversFound}
                      */}
                     </h3>
                {drivers}
            </div>
        </CardWrapper>
    );
}

export default DriverComponent;


// WEBPACK FOOTER //
// ./src/Review/DriverSectionComponent.js